<div class="upload-loading" *ngIf="is_loading || preSelectLoading">
  <div>
    <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Loading...
  </div>
</div>
<div
  class="files-manager-wrapper"
  chPaidOverlay
  [ctaText]="
    'Share files with clients and even within your firm in our intuitive File Manager'
  "
  [ctaVideo]="'https://youtu.be/Xek09bvjkCs'"
>
  <!-- Header -->
  <div class="files-manager-header">
    <div class="row d-flex align-items-center">
      <div class="col-md-9">
        <div class="breadcrumbs" *ngIf="view == 'folders'">
          <div
            class="item"
            *ngFor="let folder of breadcrumbs.folders; let i = index"
          >
            <a (click)="reopenFolder(i)">{{
              folder.name == "Staff Only" ? "Internal Folders" : folder.name
            }}</a>
          </div>
          <!-- <div class="item"><a>Home</a></div>
          <div class="item"><a>Internal Folders</a></div>
          <div class="item"><a>Folder One</a></div> -->
        </div>
        <div
          class="view-toggle"
          style="justify-content: flex-start"
          *ngIf="view == 'list'"
        >
          <span>View files:</span>
          <div
            class="view-toggle-item"
            (click)="changeListFiltering('from-client')"
            [ngClass]="{ active: listFiltering == 'from-client' }"
          >
            From Client
          </div>
          <div
            class="view-toggle-item"
            (click)="changeListFiltering('from-firm')"
            [ngClass]="{ active: listFiltering == 'from-firm' }"
          >
            From Firm
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3">
        <div class="search">
          <i class="feather search"></i>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="search"
            placeholder="Search files"
          />
        </div>
      </div> -->
      <div class="col-md-3 d-flex gap-2 align-items-center justify-content-end">
        <!-- <span>View as:</span> -->
        <div class="default-toggle" style="height: 24px">
          <div
            class="view-toggle-item"
            (click)="changeView('folders')"
            [ngClass]="{ 'filter-active': view == 'folders' }"
          >
            <i class="feather folder"></i> Folders
          </div>
          <div
            class="view-toggle-item"
            (click)="changeView('list')"
            [ngClass]="{ 'filter-active': view == 'list' }"
          >
            <i class="feather list"></i> List
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Columns -->
  <div class="files-manager-columns">
    <div class="row" *ngIf="view == 'folders'">
      <div class="col col-md-4" style="max-height: calc(100vh - 166px)">
        <!-- List files -->
        <div class="files-list">
          <!-- Title -->
          <div class="files-list-header">
            <h3>Folders</h3>
            <!--  -->
            <div *ngIf="current_data.user_type == 1">
              <div dropdown [autoClose]="true" [insideClick]="true">
                <div dropdownToggle class="dropdown-toggle">
                  <i class="feather more-horizontal gray-icon"></i>
                </div>
                <ul
                  *dropdownMenu
                  class="dropdown-menu dropdown-menu-end"
                  role="menu"
                >
                  <li (click)="openAddDefaultFoldersConfirmationModal()">
                    <a><i class="feather folder"></i> Add default folders</a>
                  </li>
                  <li (click)="downloadAllContentFromFolders()">
                    <a
                      ><i class="feather download"></i> Download all contents</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!--  -->
          </div>
          <!-- Files and Folders -->
          <div class="file-items">
            <div
              [ngClass]="{ selected: selectedFolderIndex === 3 }"
              (click)="getClientShared()"
              class="file-item"
              title="Client Shared Folder"
            >
              <div class="file-icon clients-folder"></div>
              <div class="file-name">Client Shared Folder</div>
              <div class="file-info">
                {{ fileCounters.all | i18nPlural: filePluralMapping }},
                {{ folderCounters.all | i18nPlural: folderPluralMapping }}
              </div>
            </div>
            <div
              [ngClass]="{ selected: selectedFolderIndex === 4 }"
              (click)="getStaffOnly()"
              *ngIf="current_data.user_type == 1"
              class="file-item"
              title="Internal Folders"
            >
              <div class="file-icon staff-folder"></div>
              <div class="file-name">Internal Folders</div>
              <div class="file-info">
                {{ fileCounters.staff | i18nPlural: filePluralMapping }},
                {{ folderCounters.staff | i18nPlural: folderPluralMapping }}
              </div>
            </div>
          </div>
        </div>
        <!-- List files -->
        <div class="files-list">
          <!-- Title -->
          <div class="files-list-header">
            <h3>Buckets</h3>
          </div>
          <!-- Files and Folders -->
          <div class="file-items">
            <div
              [ngClass]="{ selected: selectedFolderIndex === 12 }"
              (click)="getEasyUploadFiles()"
              class="file-item"
              title="Easy Upload"
            >
              <div class="file-icon easy-upload"></div>
              <div class="file-name">Easy Upload</div>
              <div class="file-info">
                {{ fileCounters.easyUpload | i18nPlural: filePluralMapping }}
              </div>
            </div>
            <div
              [ngClass]="{ selected: selectedFolderIndex === 1 }"
              (click)="getMessagesFiles()"
              class="file-item"
              title="Messages Files"
            >
              <div class="file-icon messages-folder"></div>
              <div class="file-name">Messages Files</div>
              <div class="file-info">
                {{ fileCounters.messages | i18nPlural: filePluralMapping }}
              </div>
            </div>
            <div
              [ngClass]="{ selected: selectedFolderIndex === 2 }"
              (click)="getTrackedItemsFiles()"
              class="file-item"
              title="Client Tasks Files"
            >
              <div class="file-icon tracked-items-folder"></div>
              <div class="file-name">Client Tasks Files</div>
              <div class="file-info">
                {{ fileCounters.tracked | i18nPlural: filePluralMapping }}
              </div>
            </div>
            <div
              [ngClass]="{ selected: selectedFolderIndex === 11 }"
              (click)="getSignatureRequests()"
              class="file-item"
              title="eSignature Docs"
            >
              <div class="file-icon signatures"></div>
              <div class="file-name">eSignature Docs</div>
              <div class="file-info">
                {{ fileCounters.eSign | i18nPlural: requestPluralMapping }}
              </div>
            </div>
          </div>
        </div>
        <!-- List files -->
        <div class="files-list">
          <!-- Title -->
          <div class="files-list-header">
            <h3>Recent Files</h3>
          </div>
          <!-- Files and Folders -->
          <div class="file-items">
            <div *ngIf="clientsFiles">
              <div
                class="recent-files-subtitle"
                *ngIf="clientsFiles.length > 0"
              >
                <h5>From Client</h5>
                <span (click)="changeView('list', 'from-client')"
                  >View All</span
                >
              </div>
              <div
                *ngFor="let file of clientsFiles; let i = index"
                [ngClass]="{ selected: selectedRecentFileIndex === i + 1 }"
                (click)="getRecentFile($event, file.etag, i + 1)"
                class="file-item selected hoverable"
                title="{{ file.filename }}"
              >
                <div
                  class="file-icon file-{{
                    file.ext != null ? file.ext.toLowerCase() : ''
                  }}"
                  [style.background-image]="'url(' + file.url + ')'"
                ></div>
                <div class="file-name">
                  {{ file.filename }}
                </div>
                <div class="file-info">
                  {{
                    file.upload_date
                      | amFromUtc
                      | amLocal
                      | amCalendar: moment_calendar_format
                  }}
                </div>
              </div>
            </div>
            <div *ngIf="staffsFiles">
              <div class="recent-files-subtitle" *ngIf="staffsFiles.length > 0">
                <h5>From Firm</h5>
                <span (click)="changeView('list', 'from-firm')">View All</span>
              </div>
              <div
                *ngFor="let file of staffsFiles; let i = index"
                [ngClass]="{ selected: selectedRecentFileIndex === i + 10 }"
                (click)="getRecentFile($event, file.etag, i + 10)"
                class="file-item selected hoverable"
                title="{{ file.filename }}"
              >
                <div
                  class="file-icon file-{{
                    file.ext != null ? file.ext.toLowerCase() : 'txt'
                  }}"
                  [style.background-image]="'url(' + file.url + ')'"
                ></div>
                <div class="file-name">
                  {{ file.filename }}
                </div>
                <div class="file-info">
                  {{
                    file.upload_date
                      | amFromUtc
                      | amLocal
                      | amCalendar: moment_calendar_format
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col col-md-4 middle-column"
        style="max-height: calc(100vh - 166px)"
        [hidden]="!navigationViewVisible"
        [ngClass]="{ 'dragging-file': isDraggingFileOverCurrentFolder }"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event, uploadFolderName)"
      >
        <!-- Upload folder name indicator -->
        <div
          class="upload-folder-name"
          [ngClass]="{ visible: isDraggingFileOverSubfolder }"
        >
          Drop files to upload them to
          <div class="folder-name text-center">
            <i *ngIf="uploadFolderName != ''" class="tio-folder"></i>
            <span>
              {{ uploadFolderName }}
            </span>
          </div>
        </div>
        <!-- List files -->
        <div class="files-list">
          <!-- Title -->
          <div class="files-list-header back">
            <i
              (click)="folderBackButton()"
              class="feather arrow-left"
              placement="right"
              tooltip="Go back"
              *ngIf="
                btnFolderBackVisible &&
                currentFolder.uuid != staffOnlyFolderUuid &&
                currentFolder.uuid != clientSharedFolderUuid
              "
            ></i>
            <h3 title="{{ currentFolder.title }}" style="flex-grow: 0">
              {{
                currentFolder.title == "Staff Only"
                  ? "Internal Folders"
                  : currentFolder.title
              }}
            </h3>

            <!-- <div class="plus-button"> -->
            <!-- </div> -->
            <span
              dropdown
              [autoClose]="true"
              id="folderActions"
              type="button"
              data-toggle="dropdown"
              container="body"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                *ngIf="
                  breadcrumbs.folders.length > 2 &&
                  localStorage.get('data')['user_type'] == 1 &&
                  selectedFolderIndex != 11 &&
                  bulkActionSelectedFolders.length == 0 &&
                  bulkActionSelectedFiles.length == 0
                "
                dropdownToggle
                ><i class="feather more-horizontal gray-icon"></i
              ></span>
              <ul
                *dropdownMenu
                class="dropdown-menu dropdown-menu-end adjust-dropdown-end"
                aria-labelledby="folderActions"
              >
                <li>
                  <a (click)="renameFolderVisible = true">Rename Folder</a>
                </li>
                <li><a (click)="openModalMoveFolder()">Move Folder</a></li>
                <li>
                  <a (click)="openDeleteConfirmationModal()">Delete Folder</a>
                </li>
                <li
                  *ngIf="
                    currentFolder.folders?.length > 0 ||
                    currentFolder.files?.length > 0
                  "
                >
                  <a (click)="zipAndDownloadFolderFiles()"
                    >Download All Content</a
                  >
                </li>
              </ul>
            </span>
            <div
              class="d-flex align-items-center justify-content-end flex-grow"
            >
              <div class="files-sort-wrapper">
                <div dropdown [autoClose]="true" class="files-sort-dropdown">
                  <div dropdownToggle class="dropdown-toggle">
                    <i class="tio-sort"></i> {{ orderByLabel }}
                    <i class="feather chevron-down"></i>
                  </div>
                  <ul
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    style="inset: 100% auto auto -80px !important"
                  >
                    <li>
                      <a (click)="changeOrderBy('date', 'Date (Oldest)')"
                        >Date (Oldest)</a
                      >
                    </li>
                    <li>
                      <a (click)="changeOrderBy('-date', 'Date (Newest)')"
                        >Date (Newest)</a
                      >
                    </li>
                    <li><a (click)="changeOrderBy('name', 'Name')">Name</a></li>
                  </ul>
                </div>
              </div>
              <span
                dropdown
                container="body"
                [autoClose]="true"
                *ngIf="btnFolderOperationsVisible && selectedFolderIndex != 11"
                class="dropdown plus-button"
              >
                <span
                  id="dLabel"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  dropdownToggle
                >
                  <i class="feather plus"></i>
                </span>
                <ul
                  class="dropdown-menu dropdown-menu-end adjust-dropdown-end"
                  *dropdownMenu
                  aria-labelledby="dLabel"
                >
                  <li *ngIf="current_data.user_type == 1">
                    <a (click)="openFolderForm()">New Folder</a>
                  </li>
                  <li>
                    <a (click)="openModalFileUpload(null)">Upload Files</a>
                  </li>
                </ul>
              </span>

              <span
                *ngIf="
                  selectedFolderIndex === 11 && current_data.user_type == 1
                "
                class="plus-button"
                dropdown
                [autoClose]="true"
                placement="bottom right"
              >
                <span id="dLabel" dropdownToggle>
                  <i class="feather plus"></i>
                </span>
                <ul
                  class="dropdown-menu dropdown-menu-end"
                  *dropdownMenu
                  aria-labelledby="dLabel"
                >
                  <li>
                    <a (click)="openSignatureRequestModal()"
                      >Request eSignature</a
                    >
                  </li>
                </ul>
              </span>
            </div>
          </div>

          <!-- Create a new folder -->
          <div class="file-items" [hidden]="!newFolderVisible">
            <input
              #txtNewFolder
              type="text"
              class="form-control rename-file-input"
              style="text-align: center; font-weight: 600"
              value=""
            />
            <div class="row">
              <div class="col-sm-6">
                <button
                  class="btn btn-default btn-block"
                  (click)="openFolderForm()"
                >
                  Cancel
                </button>
              </div>
              <div class="col-sm-6">
                <button
                  class="btn btn-primary btn-block"
                  (click)="createFolder(txtNewFolder.value)"
                >
                  Create
                </button>
              </div>
            </div>
          </div>

          <!-- Rename a folder -->
          <div class="file-items" *ngIf="renameFolderVisible">
            <input
              #txtRenameFolder
              type="text"
              class="form-control rename-file-input"
              style="text-align: center; font-weight: 600"
              value=""
            />
            <div class="row">
              <div class="col-sm-6">
                <button
                  class="btn btn-default btn-block"
                  (click)="renameFolderVisible = false"
                >
                  Cancel
                </button>
              </div>
              <div class="col-sm-6">
                <button
                  class="btn btn-primary btn-block"
                  (click)="
                    renameFolder(currentFolder.uuid, txtRenameFolder.value)
                  "
                >
                  Rename
                </button>
              </div>
            </div>
          </div>
          <div class="file-items" *ngIf="currentFolder.files?.length > 0">
            <a
              class="select-link"
              *ngIf="
                currentFolder.files?.length !== bulkActionSelectedFiles.length
              "
              (click)="bulkSelectUnselectAllFiles('select')"
              >Select all files</a
            >
            <a
              class="select-link"
              (click)="bulkSelectUnselectAllFiles('unselect')"
              *ngIf="
                currentFolder.files?.length ===
                  bulkActionSelectedFiles.length &&
                currentFolder.files?.length > 0
              "
              >Unselect all files</a
            >
          </div>

          <!-- Files and Folders -->
          <div class="file-items" *ngIf="!newFolderVisible">
            <div
              *ngFor="let folder of currentFolder.folders"
              (click)="getFolder(folder.uuid, $event)"
              [ngClass]="{
                'file-item': true,
                hoverable: current_data.access_level == 1,
              }"
              title="{{ folder.name }}"
              (dragover)="onDragOverFolder($event, folder)"
              (dragleave)="onDragLeaveFolder($event)"
              (drop)="onFileDropFolder($event, folder)"
            >
              <div class="file-icon regular-folder"></div>
              <div class="file-name">{{ folder.name }}</div>
              <div class="file-info">
                {{ folder.file_count | i18nPlural: filePluralMapping }},
                {{ folder.folder_count | i18nPlural: folderPluralMapping }}
              </div>
            </div>
            <div
              *ngFor="let file of currentFolder.files; let i = index"
              [ngClass]="{ selected: selectedFileIndex === i + 1 }"
              (click)="getFile($event, file.etag, i + 1)"
              class="file-item hoverable"
              title="{{ file.filename }}"
              #fileElement
            >
              <div
                class="file-icon file-{{
                  file.ext != null ? file.ext.toLowerCase() : ''
                }}"
                [style.background-image]="'url(' + file.url + ')'"
              ></div>
              <div class="file-name">{{ file.filename }}</div>
              <div class="file-info">
                {{
                  file.upload_date
                    | amFromUtc
                    | amLocal
                    | amCalendar: moment_calendar_format
                }}
              </div>
            </div>
            <ng-container *ngIf="selectedFolderIndex === 11">
              <div
                *ngFor="let signRequest of signatureRequests; let i = index"
                [ngClass]="{ selected: selectedFileIndex === i + 1 }"
                (click)="getSignatureRequest(i + 1, signRequest.id)"
                class="sign-request-item file-item hoverable"
                title="{{ signRequest.request_name }} | {{ signRequest.status }}"
              >
              <div class="file-wrapper">
                <div class="file-name">
                  {{ signRequest.request_name }} | {{ signRequest.status }}
                </div>
                <div class="file-info">
                  {{
                    signRequest.modified_date
                    | amFromUtc
                    | amLocal
                    | amCalendar: moment_calendar_format
                  }}
                  </div>
              </div>
                <div class="select-sign-request-icon" (click)="selectSignatureRequest($event, i + 1, signRequest.id)">
                <i class="{{ selectedFileIndex === i + 1 ? 'tio-back_ui' : 'tio-next_ui' }}"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col col-md-4 shaded">
        @if (selectedFolderIndex === 11
            && current_data.user_type == 1
            && showSignatureRequestDetails) {
          <div class="file-actions-panel file-preview no-file">

            <div class="signature-request-file-wrapper">
              <div class="signature-preview"></div>
              
              <span>{{ selectedSignatureRequest.request_name }}</span>
              <span>Request created on: {{ selectedSignatureRequest.created_date | amFromUtc | amLocal | amCalendar: moment_calendar_format }}</span>
              <span>Last modified on: {{ selectedSignatureRequest.modified_date | amFromUtc | amLocal | amCalendar: moment_calendar_format }}</span>
              <span>Status: {{ selectedSignatureRequest.status }}</span>
            </div>
          </div>
          <div class="file-actions-panel">
            <h4>ACTIONS</h4>
            <button
              class="btn btn-white btn-block btn-danger"
              [disabled]="selectedSignatureRequest?.status == 'Completed'"
              (click)="confirmDocumentDelete()"
            >Delete Request</button>
          </div>
        }
        <div
          class="file-actions-panel"
          [hidden]="
            !fileViewVisible &&
            bulkActionSelectedFiles.length == 0 &&
            bulkActionSelectedFolders.length == 0
          "
        >
          <ng-container *ngTemplateOutlet="showNoPreviewMessage"></ng-container>
          <ng-template #showNoPreviewMessage>
            <div class="file-preview no-file">
              <span
                *ngIf="
                  bulkActionSelectedFiles.length > 0 ||
                  bulkActionSelectedFolders.length > 0
                "
              >
                <svg
                  style="margin-bottom: 24px"
                  width="220"
                  height="201"
                  viewBox="0 0 220 201"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2105:59)">
                    <path
                      d="M26.0491 37.1013C56.0686 1.35516 102.277 0.385241 119.082 0.0325456C162.151 -0.87223 216.381 17.1113 219.437 42.2742C222.057 63.8276 184.944 72.7117 177.658 114.256C173.717 136.736 183.027 142.986 177.658 156.928C163.975 192.461 75.8976 223.527 27.3406 178.911C-12.0659 142.7 -5.6372 74.8303 26.0491 37.1013Z"
                      fill="#ECF3FE"
                    />
                    <g style="mix-blend-mode: multiply" opacity="0.2">
                      <path
                        d="M207.286 59.8733L121.36 54.976C120.513 54.93 119.681 55.2217 119.048 55.7874C118.415 56.353 118.031 57.1466 117.981 57.9946L111.531 171.296C111.485 172.144 111.777 172.976 112.342 173.609C112.907 174.243 113.7 174.627 114.548 174.677L200.474 179.575C201.321 179.621 202.153 179.329 202.786 178.763C203.419 178.198 203.803 177.404 203.853 176.556L210.3 63.2541C210.346 62.4063 210.054 61.575 209.49 60.9415C208.925 60.3081 208.133 59.9241 207.286 59.8733V59.8733Z"
                        fill="#3A7EC1"
                      />
                    </g>
                    <path
                      d="M204.447 187.634C204.318 187.634 204.19 187.627 204.062 187.614L118.474 178.558C117.516 178.456 116.638 177.977 116.033 177.228C115.427 176.478 115.143 175.519 115.243 174.56L127.168 61.7042C127.272 60.7462 127.751 59.8682 128.499 59.2622C129.248 58.6563 130.206 58.3716 131.164 58.4704L216.752 67.5261C217.709 67.6288 218.587 68.1073 219.193 68.8567C219.799 69.6062 220.083 70.5654 219.983 71.5241L208.058 184.384C207.961 185.276 207.539 186.1 206.873 186.7C206.207 187.3 205.343 187.632 204.447 187.634V187.634ZM130.777 59.3124C130.093 59.3152 129.434 59.5699 128.926 60.0277C128.418 60.4856 128.097 61.1146 128.022 61.7948L116.1 174.651C116.024 175.382 116.241 176.114 116.703 176.685C117.165 177.257 117.834 177.622 118.565 177.701L204.153 186.757C204.884 186.832 205.614 186.615 206.185 186.153C206.756 185.691 207.121 185.021 207.2 184.29L219.123 71.4335C219.198 70.7024 218.981 69.9712 218.519 69.3997C218.057 68.8283 217.388 68.4631 216.658 68.384L131.07 59.3283C130.973 59.3179 130.875 59.3126 130.777 59.3124V59.3124Z"
                      fill="#444444"
                    />
                    <path
                      d="M198.315 177.732L112.389 172.835C111.542 172.784 110.749 172.4 110.184 171.767C109.619 171.133 109.327 170.301 109.373 169.453L115.821 56.1501C115.871 55.3022 116.254 54.5086 116.888 53.9429C117.521 53.3773 118.352 53.0855 119.2 53.1316L205.125 58.028C205.973 58.0784 206.766 58.4625 207.331 59.0963C207.896 59.7301 208.188 60.5621 208.142 61.4104L201.694 174.712C201.644 175.56 201.26 176.354 200.627 176.92C199.994 177.485 199.162 177.777 198.315 177.732V177.732Z"
                      fill="#3B82F4"
                    />
                    <path
                      d="M193.639 89.5323L127.042 85.7368C126.495 85.7041 125.983 85.4559 125.618 85.0466C125.253 84.6372 125.065 84.1 125.095 83.5523V83.5523C125.128 83.0049 125.375 82.4926 125.784 82.1274C126.193 81.7623 126.73 81.574 127.277 81.6038L193.874 85.3992C194.421 85.4318 194.933 85.6798 195.298 86.089C195.663 86.4982 195.851 87.0353 195.821 87.5829V87.5829C195.788 88.1304 195.541 88.6426 195.132 89.0078C194.723 89.3731 194.186 89.5616 193.639 89.5323V89.5323Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M192.79 104.465L126.193 100.668C125.646 100.636 125.134 100.388 124.769 99.9786C124.404 99.5695 124.215 99.0324 124.245 98.4847C124.278 97.9372 124.526 97.4249 124.935 97.0597C125.344 96.6945 125.88 96.506 126.428 96.5353L193.025 100.332C193.572 100.364 194.084 100.612 194.449 101.021C194.814 101.43 195.002 101.968 194.973 102.515V102.515C194.94 103.063 194.692 103.575 194.283 103.94C193.874 104.305 193.337 104.494 192.79 104.465V104.465Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M191.94 119.396L125.343 115.601C124.796 115.568 124.284 115.32 123.919 114.911C123.554 114.502 123.366 113.965 123.396 113.417V113.417C123.428 112.87 123.676 112.357 124.085 111.992C124.494 111.627 125.03 111.438 125.578 111.468L192.175 115.263C192.722 115.296 193.234 115.544 193.599 115.953C193.963 116.363 194.151 116.9 194.122 117.448V117.448C194.089 117.995 193.841 118.507 193.432 118.872C193.023 119.237 192.487 119.426 191.94 119.396Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M191.09 134.328L124.493 130.533C123.946 130.5 123.434 130.252 123.069 129.843C122.705 129.433 122.516 128.896 122.545 128.349V128.349C122.578 127.801 122.826 127.289 123.235 126.924C123.644 126.559 124.181 126.37 124.728 126.4L191.325 130.195C191.872 130.228 192.384 130.476 192.749 130.886C193.114 131.295 193.303 131.832 193.273 132.38C193.24 132.927 192.992 133.439 192.583 133.804C192.174 134.169 191.637 134.358 191.09 134.328V134.328Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M190.241 149.261L123.644 145.465C123.097 145.433 122.585 145.185 122.22 144.775C121.855 144.366 121.667 143.829 121.697 143.281V143.281C121.729 142.734 121.977 142.221 122.386 141.856C122.795 141.491 123.332 141.303 123.879 141.332L190.476 145.128C191.023 145.16 191.535 145.408 191.9 145.818C192.265 146.227 192.453 146.764 192.423 147.312V147.312C192.39 147.859 192.143 148.371 191.734 148.736C191.325 149.102 190.788 149.29 190.241 149.261V149.261Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M189.391 164.193L122.794 160.397C122.247 160.364 121.735 160.116 121.37 159.707C121.005 159.298 120.817 158.761 120.846 158.213V158.213C120.879 157.666 121.127 157.154 121.536 156.788C121.945 156.423 122.482 156.235 123.029 156.264L189.626 160.06C190.173 160.093 190.685 160.341 191.05 160.75C191.414 161.159 191.603 161.696 191.574 162.244C191.541 162.792 191.293 163.304 190.884 163.669C190.475 164.034 189.938 164.222 189.391 164.193V164.193Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M194.489 74.6039L127.892 70.8085C127.345 70.7757 126.833 70.5276 126.468 70.1183C126.103 69.709 125.915 69.1718 125.944 68.624V68.624C125.978 68.0766 126.226 67.5646 126.635 67.1996C127.044 66.8346 127.58 66.6461 128.127 66.6755L194.724 70.4709C195.271 70.5039 195.783 70.7521 196.148 71.1613C196.513 71.5706 196.701 72.1076 196.672 72.6554V72.6554C196.639 73.2029 196.391 73.7152 195.982 74.0803C195.573 74.4454 195.037 74.6337 194.489 74.6039V74.6039Z"
                      fill="#B3CEF6"
                    />
                    <path
                      d="M137.857 128.795L78.6557 151.728C76.541 152.547 74.838 154.174 73.9215 156.25C73.005 158.325 72.95 160.68 73.7685 162.797V162.797C74.5872 164.913 76.2123 166.617 78.2865 167.535C80.3608 168.452 82.7141 168.507 84.8289 167.688L140.617 146.081C141.522 145.73 142.251 145.034 142.643 144.145C143.036 143.257 143.059 142.249 142.709 141.343L137.857 128.795Z"
                      fill="#C1822F"
                    />
                    <g style="mix-blend-mode: multiply" opacity="0.2">
                      <path
                        d="M173.14 44.2697L87.3753 51.4594C86.5299 51.5328 85.7479 51.938 85.2 52.5865C84.6521 53.2349 84.3829 54.074 84.4511 54.9204L93.9175 168.01C93.9909 168.857 94.3959 169.639 95.044 170.188C95.6921 170.736 96.5308 171.005 97.3767 170.937L183.141 163.746C183.986 163.673 184.768 163.268 185.316 162.619C185.864 161.971 186.133 161.132 186.065 160.285L176.598 47.1985C176.526 46.3519 176.121 45.5684 175.473 45.0195C174.825 44.4707 173.986 44.201 173.14 44.2697Z"
                        fill="#3A7EC1"
                      />
                    </g>
                    <path
                      d="M180.648 161.293L94.8843 168.483C94.0386 168.552 93.2002 168.282 92.5521 167.734C91.904 167.186 91.4988 166.404 91.4251 165.558L81.9586 52.4667C81.8905 51.6202 82.1597 50.7812 82.7076 50.1327C83.2555 49.4842 84.0375 49.0791 84.8829 49.0056L170.648 41.8159C171.494 41.7474 172.332 42.0168 172.98 42.5652C173.628 43.1135 174.033 43.8962 174.106 44.7423L183.573 157.831C183.641 158.678 183.372 159.517 182.824 160.166C182.276 160.815 181.494 161.22 180.648 161.293Z"
                      fill="white"
                    />
                    <path
                      d="M163.682 74.6172L97.2069 80.1897C96.6606 80.2339 96.119 80.06 95.7005 79.7059C95.282 79.3518 95.0205 78.8463 94.9732 78.2999C94.929 77.7532 95.1028 77.2113 95.4566 76.7924C95.8105 76.3736 96.3155 76.1119 96.8616 76.0646L163.336 70.4921C163.883 70.4479 164.424 70.6218 164.843 70.9759C165.261 71.33 165.523 71.8355 165.57 72.3819V72.3819C165.614 72.9285 165.44 73.4704 165.086 73.8892C164.733 74.308 164.228 74.5697 163.682 74.6172V74.6172Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M164.928 89.5211L98.4531 95.0983C97.9068 95.1423 97.3654 94.9683 96.9469 94.6143C96.5284 94.2602 96.2669 93.7549 96.2194 93.2085V93.2085C96.1752 92.6619 96.349 92.1199 96.7028 91.7011C97.0567 91.2822 97.5618 91.0205 98.1078 90.9732L164.583 85.4C165.129 85.3556 165.671 85.5294 166.089 85.8836C166.508 86.2377 166.769 86.7433 166.816 87.2898V87.2898C166.86 87.8359 166.685 88.3769 166.332 88.7949C165.978 89.2129 165.473 89.474 164.928 89.5211V89.5211Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M166.176 104.426L99.704 109.998C99.1578 110.043 98.6162 109.869 98.1977 109.514C97.7792 109.16 97.5177 108.655 97.4704 108.108V108.108C97.4262 107.562 97.6 107.02 97.9538 106.601C98.3076 106.182 98.8127 105.92 99.3588 105.873L165.834 100.301C166.38 100.256 166.921 100.43 167.34 100.784C167.758 101.138 168.02 101.644 168.067 102.19V102.19C168.111 102.738 167.937 103.28 167.583 103.699C167.228 104.118 166.722 104.379 166.176 104.426V104.426Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M167.423 119.326L100.949 124.899C100.402 124.944 99.8608 124.77 99.4423 124.416C99.0238 124.062 98.7623 123.556 98.715 123.01C98.6708 122.463 98.8446 121.921 99.1984 121.502C99.5522 121.083 100.057 120.821 100.603 120.774L167.078 115.201C167.624 115.157 168.166 115.331 168.584 115.685C169.003 116.039 169.264 116.544 169.312 117.091V117.091C169.356 117.638 169.182 118.18 168.828 118.598C168.474 119.017 167.969 119.279 167.423 119.326V119.326Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M168.671 134.234L102.196 139.806C101.65 139.851 101.108 139.677 100.69 139.323C100.271 138.969 100.01 138.463 99.962 137.917C99.918 137.37 100.092 136.828 100.446 136.409C100.8 135.99 101.305 135.729 101.851 135.681L168.326 130.108C168.872 130.064 169.414 130.238 169.832 130.592C170.251 130.947 170.512 131.452 170.56 131.999V131.999C170.604 132.545 170.43 133.087 170.076 133.506C169.722 133.925 169.217 134.187 168.671 134.234Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M169.918 149.138L103.443 154.711C102.897 154.755 102.356 154.581 101.937 154.227C101.519 153.872 101.257 153.367 101.21 152.82C101.166 152.274 101.34 151.732 101.694 151.313C102.047 150.894 102.552 150.633 103.098 150.585L169.573 145.013C170.119 144.968 170.661 145.142 171.079 145.496C171.498 145.85 171.759 146.356 171.807 146.902V146.902C171.851 147.449 171.677 147.991 171.323 148.41C170.969 148.829 170.464 149.09 169.918 149.138Z"
                      fill="#E4ECF9"
                    />
                    <path
                      d="M162.433 59.7136L95.9583 65.286C95.4121 65.3303 94.8705 65.1563 94.452 64.8022C94.0334 64.4482 93.772 63.9427 93.7247 63.3963V63.3963C93.6805 62.8496 93.8543 62.3076 94.2081 61.8888C94.5619 61.4699 95.067 61.2082 95.613 61.1609L162.088 55.5876C162.634 55.5436 163.176 55.7176 163.594 56.0717C164.013 56.4257 164.274 56.9311 164.322 57.4774C164.366 58.0242 164.192 58.5663 163.838 58.9852C163.484 59.4042 162.979 59.6661 162.433 59.7136V59.7136Z"
                      fill="#52D1BD"
                    />
                    <g style="mix-blend-mode: multiply" opacity="0.2">
                      <path
                        d="M132.335 21.9037L146.253 57.8881C146.73 59.1228 146.698 60.4967 146.163 61.7077C145.629 62.9186 144.635 63.8674 143.402 64.3455L135.492 67.4101L157.116 123.317C157.558 124.461 157.528 125.733 157.032 126.854C156.536 127.975 155.616 128.853 154.474 129.296L90.4646 154.091L89.8844 147.378L39.9693 61.5073C39.5637 60.4594 39.3684 59.3419 39.3944 58.2184C39.4204 57.095 39.6673 55.9877 40.121 54.9598C40.5747 53.9319 41.2263 53.0035 42.0385 52.2276C42.8508 51.4517 43.8078 50.8436 44.8549 50.4379L125.882 19.0503C127.116 18.5725 128.488 18.6047 129.699 19.1398C130.909 19.6749 131.857 20.669 132.335 21.9037V21.9037Z"
                        fill="#3A7EC1"
                      />
                    </g>
                    <path
                      d="M150.108 119.094L128.482 63.1881L136.392 60.1219C137.003 59.8855 137.562 59.531 138.036 59.0786C138.51 58.6261 138.89 58.0846 139.155 57.4851C139.42 56.8855 139.564 56.2395 139.58 55.5842C139.595 54.9288 139.481 54.2767 139.245 53.6653L125.325 17.6808C125.088 17.0693 124.734 16.5105 124.282 16.0361C123.83 15.5618 123.289 15.1813 122.689 14.9163C122.09 14.6514 121.445 14.5073 120.79 14.4922C120.135 14.4771 119.484 14.5913 118.873 14.8283L37.8436 46.2174C36.7964 46.623 35.8392 47.231 35.0268 48.0069C34.2144 48.7827 33.5627 49.7111 33.1089 50.7391C32.6552 51.767 32.4082 52.8744 32.3822 53.9979C32.3561 55.1213 32.5516 56.2389 32.9572 57.2868L40.9044 77.8369L51.0749 104.126L70.6809 154.818L73.7679 162.797C72.9515 160.688 73.0033 158.34 73.9119 156.269C74.8205 154.198 76.512 152.571 78.6162 151.744L147.462 125.074C148.605 124.633 149.526 123.754 150.023 122.633C150.519 121.511 150.55 120.239 150.108 119.094V119.094Z"
                      fill="#F9C067"
                    />
                    <path
                      d="M38.1873 171.033C36.8126 170.6 35.6657 169.638 34.9983 168.36C34.3309 167.081 34.1975 165.59 34.6273 164.213L41.8037 141.325C42.4474 139.337 43.8493 137.684 45.7044 136.725C47.5595 135.767 49.7178 135.58 51.7099 136.205C53.7021 136.83 55.3669 138.218 56.3423 140.065C57.3177 141.913 57.5248 144.071 56.9186 146.07L54.9961 152.202C54.9557 152.317 54.8723 152.411 54.7635 152.466C54.6548 152.52 54.5291 152.53 54.4131 152.494C54.2971 152.457 54.1998 152.377 54.1417 152.27C54.0835 152.163 54.0692 152.038 54.1016 151.921L56.0241 145.79C56.5342 144.034 56.3366 142.148 55.4737 140.536C54.6108 138.925 53.1512 137.716 51.4079 137.168C49.6647 136.621 47.7765 136.779 46.1482 137.608C44.5199 138.437 43.2811 139.872 42.6975 141.605L35.5219 164.494C35.345 165.058 35.2808 165.651 35.3332 166.24C35.3855 166.829 35.5532 167.402 35.8268 167.926C36.3793 168.985 37.3293 169.781 38.4679 170.138C39.6065 170.496 40.8404 170.386 41.8981 169.833C42.9558 169.28 43.7508 168.329 44.108 167.19L51.4805 143.677C51.6356 143.168 51.5834 142.618 51.3354 142.147C51.0873 141.677 50.6634 141.323 50.1561 141.164C49.6488 141.005 49.0991 141.052 48.6268 141.297C48.1545 141.541 47.798 141.963 47.6347 142.469L41.5029 162.026C41.4624 162.141 41.3791 162.236 41.2703 162.29C41.1615 162.345 41.0359 162.355 40.9199 162.318C40.8039 162.282 40.7066 162.202 40.6484 162.095C40.5903 161.988 40.5759 161.863 40.6083 161.745L46.7402 142.189C46.8562 141.818 47.0441 141.475 47.2929 141.177C47.5417 140.879 47.8467 140.634 48.1905 140.454C48.5342 140.274 48.91 140.164 49.2963 140.129C49.6826 140.095 50.0718 140.137 50.4419 140.253C50.8119 140.369 51.1555 140.557 51.453 140.806C51.7504 141.056 51.996 141.361 52.1756 141.705C52.3551 142.049 52.4653 142.425 52.4997 142.811C52.534 143.198 52.492 143.588 52.3759 143.958L45.0034 167.471C44.5704 168.847 43.6095 169.995 42.3316 170.663C41.0537 171.331 39.5632 171.464 38.1873 171.033V171.033Z"
                      fill="#444444"
                    />
                    <path
                      d="M79.4496 91.9868C78.1124 93.264 76.5362 94.2641 74.8116 94.9299L51.078 104.124L40.9075 77.8353L64.6435 68.6381C67.6831 67.4613 71.0364 67.3756 74.132 68.3957C77.2277 69.4157 79.8741 71.4784 81.6204 74.2323C83.3667 76.9861 84.1048 80.2608 83.709 83.4982C83.3132 86.7356 81.8079 89.7356 79.4496 91.9868V91.9868Z"
                      fill="#E5A755"
                    />
                    <path
                      d="M83.8049 72.0389C84.4738 73.765 84.7961 75.6061 84.7534 77.457C84.7107 79.3079 84.3039 81.1321 83.5561 82.8255C82.8083 84.5189 81.7344 86.0482 80.3956 87.3259C79.0568 88.6036 77.4795 89.6046 75.7538 90.2718L48.2577 100.923C47.3167 101.289 46.5591 102.013 46.1513 102.938C45.7435 103.862 45.7189 104.91 46.0828 105.852L44.708 102.298L23.1795 110.639L16.835 94.2388C18.2482 92.7822 19.9603 91.6497 21.8531 90.9192L37.9007 84.7025L35.9123 79.563C35.5496 78.6212 35.5749 77.5739 35.9826 76.6507C36.3903 75.7274 37.1471 75.0037 38.0872 74.638L65.5841 63.9864C67.3089 63.3178 69.1485 62.9958 70.9977 63.0388C72.847 63.0819 74.6696 63.4891 76.3615 64.2373C78.0535 64.9854 79.5815 66.0598 80.8584 67.3991C82.1353 68.7384 83.136 70.3164 83.8034 72.0428L83.8049 72.0389Z"
                      fill="#3B82F4"
                    />
                    <path
                      d="M37.9022 84.7025L46.6963 107.439C47.0601 108.381 47.0352 109.43 46.6271 110.354C46.2191 111.278 45.4611 112.002 44.5198 112.368L32.0235 117.208C28.5394 118.558 24.6624 118.467 21.2452 116.956C17.8281 115.445 15.1508 112.637 13.8023 109.15C12.4538 105.663 12.5446 101.783 14.0547 98.3637C15.5648 94.944 18.3705 92.2647 21.8546 90.9152L37.9022 84.7025Z"
                      fill="#2670DB"
                    />
                    <path
                      d="M164.751 24.8846C166.653 22.9808 166.653 19.8942 164.751 17.9904C162.849 16.0866 159.764 16.0866 157.862 17.9904C155.959 19.8942 155.959 22.9808 157.862 24.8846C159.764 26.7884 162.849 26.7884 164.751 24.8846Z"
                      fill="#3B82F4"
                    />
                    <path
                      d="M8.31609 47.7053C10.2185 45.8015 10.2185 42.7148 8.31609 40.811C6.41372 38.9072 3.32936 38.9072 1.42698 40.811C-0.475397 42.7148 -0.475397 45.8015 1.42698 47.7053C3.32936 49.6091 6.41372 49.6091 8.31609 47.7053Z"
                      fill="#3B82F4"
                    />
                    <path
                      d="M79.6536 192.033C81.3401 192.033 82.7072 190.665 82.7072 188.977C82.7072 187.29 81.3401 185.921 79.6536 185.921C77.9671 185.921 76.6 187.29 76.6 188.977C76.6 190.665 77.9671 192.033 79.6536 192.033Z"
                      fill="#3B82F4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2105:59">
                      <rect width="220" height="201" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <br />
                {{
                  bulkActionSelectedFiles.length | i18nPlural: filePluralMapping
                }}
                and
                {{
                  bulkActionSelectedFolders.length
                    | i18nPlural: folderPluralMapping
                }}
                selected</span
              >
            </div>
          </ng-template>
          <!-- <secured-image [src]="fileDetails.etag"></secured-image> -->
          <!-- Renaming a file -->
          <div *ngIf="renamingFile">
            <input
              #txtRenameFile
              type="text"
              class="form-control rename-file-input"
              style="text-align: center; font-weight: 600"
              value="{{
                fileDetails.filename.substring(
                  0,
                  fileDetails.filename.lastIndexOf('.')
                )
              }}"
            />
            <div class="row">
              <div class="col-sm-6">
                <button
                  class="btn btn-default btn-block"
                  (click)="openRenameFile()"
                >
                  Cancel
                </button>
              </div>
              <div class="col-sm-6">
                <button
                  class="btn btn-primary btn-block"
                  (click)="renameFile(fileDetails.etag, txtRenameFile.value)"
                >
                  Rename
                </button>
              </div>
            </div>
          </div>

          <div
            #multipleFilesSelected
            class="file-actions-wrapper"
            *ngIf="
              bulkActionSelectedFiles.length > 0 ||
              bulkActionSelectedFolders.length > 0
            "
          >
            <h4>ACTIONS</h4>
            <button
              *ngIf="bulkActionSelectedFolders.length == 0"
              class="btn btn-white btn-block"
              (click)="downloadSelected()"
            >
              <i class="feather download"></i> Download All
            </button>
            <!-- <button
              class="btn btn-white btn-block"
              *ngIf="current_data.user_type == 1"
              (click)="openModalMoveFile(true)"
            >
              <i class="feather corner-up-left"></i> Move All to Folder
            </button> -->
            <button
              class="btn btn-white btn-block"
              *ngIf="current_data.user_type == 1"
              (click)="openModalForCutOrCopyFoldersAndFiles('cut')"
            >
              <i class="feather arrow-up-right"></i> Move selected files &
              folders
            </button>
            <button
              class="btn btn-white btn-block"
              *ngIf="current_data.user_type == 1"
              (click)="openModalForCutOrCopyFoldersAndFiles('copy')"
            >
              <i class="feather copy"></i> Copy selected files & folders
            </button>
            <button
              class="btn btn-white btn-block"
              (click)="deleteSelected()"
              *ngIf="
                (current_data.user_type == 1 || checkClientForDeleteFile()) &&
                bulkActionSelectedFolders.length == 0
              "
            >
              <i class="feather delete"></i> Delete All
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="view == 'list'">
      <app-files-table-view
        [listFiltering]="listFiltering"
      ></app-files-table-view>
    </div>
  </div>
</div>
<!-- .files-manager-wrapper -->
<ng-template #deleteModal>
  <div class="modal-header text-center" style="border-bottom: none">
    <!-- <i class="feather check-circle x3" style="color: #0084ff;"></i> -->
    <div>
      <h4>Are you sure?</h4>
      <p>
        You are about to delete the file
        <strong>{{ fileDetails.filename }}</strong
        >.<br />
        If you want to proceed, click delete.
        <!-- <a routerLink="/terms-of-service" target="_blank" rel="noreferrer noopener">Terms of Service</a> and
      <a routerLink="/privacy-policy" target="_blank" rel="noreferrer noopener">Privacy Policy</a>. -->
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsDeleteModalRef.hide()"
    >
      Cancel
    </div>
    <div
      class="btn btn-danger pull-right"
      (click)="deleteFile(fileDetails.etag)"
    >
      Delete
    </div>
  </div>
</ng-template>

<!-- Upload drag and drop progress -->
<div class="upload-progress-wrapper" [ngClass]="{ visible: uploadListOpen }">
  <div class="upload-progress-header">
    <span class="d-inline-flex gap-2">
      {{ totalUploadedFiles - uploadErrors }}/{{ uploadList.length }} file{{
        uploadList.length > 1 ? "s" : ""
      }}
      uploaded
      @if (uploadErrors) {
        <div class="error-badge">
          {{ uploadErrors }} error{{ uploadErrors > 1 ? "s" : "" }}
        </div>
      }
    </span>
    <div class="gap-2 d-flex">
      <div class="close" (click)="uploadListCollapsed = !uploadListCollapsed">
        @if (uploadListCollapsed) {
          <i class="feather chevron-up"></i>
        } @else {
          <i class="feather chevron-down"></i>
        }
      </div>
      <div class="close" (click)="uploadListOpen = false">
        <i class="feather x"></i>
      </div>
    </div>
  </div>
  <div class="upload-progress-body" *ngIf="!uploadListCollapsed">
    <div
      class="upload-group"
      *ngFor="let files of uploadList.slice() | groupBy: 'group' | keyvalue"
    >
      <div class="folder-group">
        <i class="feather folder fw-bold"></i>
        <div class="folder-name" [title]="files.key">{{ files.key }}</div>
        <div class="folder-items">
          {{ countItems(files.key, 100) }}/{{ files.value.length }} uploaded
        </div>
      </div>
      <div
        *ngFor="let file of files.value"
        class="upload-progress-item"
        [ngClass]="{ error: file.progress === 'error' }"
      >
        <div class="upload-progress-file" title="{{ file.filename }}">
          <div class="upload-progress-file-wrapper">
            <div class="upload-progress-icon">
              <i class="feather file"></i>
            </div>
            <div class="upload-progress-name">
              {{ file.filename }}
              <br />
              <span style="font-size: 12px; opacity: 0.5">{{
                file.folder.substring(0, file.folder.lastIndexOf("/"))
              }}</span>
            </div>
          </div>
          <div class="upload-progress-bar">
            @if (file.progress > 0) {
              <div
                class="upload-progress-circle"
                title="Uploading..."
                [ngStyle]="{
                  background:
                    'radial-gradient(closest-side, white 0, transparent 0 100%), conic-gradient(#2f9139 ' +
                    file.progress +
                    '%, #f0f0f0 0)',
                }"
              >
                @if (file.progress === 100 && file.status != "completed") {
                  <div
                    class="upload-progress-processing"
                    title="Processing file"
                  ></div>
                } @else if (
                  file.progress === 100 && file.status === "completed"
                ) {
                  <div class="upload-progress-complete" title="Upload complete">
                    <i class="feather check"></i>
                  </div>
                }
              </div>
            }
            @if (file.progress === "error") {
              <div class="upload-error" title="{{ file.errorMsg }}">
                <i class="feather x"></i>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Upload drag and drop progress -->
